import { actionAddException } from 'react-redux-app/lib/modules/exception/actions';
import { actionAddServerTime } from 'react-redux-app/lib/modules/dateTime/actions';
import { actionAddTranslations } from '../../core/i18n/actions';
import {
  actionAddLaunchAffiliateToolUrl,
  actionAddPromotedSites,
} from '../../affiliateTools/actions';
import { actionAddAllPromotedSiteToWlTemplateToLangs } from '../../siteBuilder/actions';
import { actionAddSiteTextsDefaultTranslations } from '../../siteTexts/actions';
import {
  actionAddTemplateToCategoriesMap,
  actionAddDefaultSiteLinkCategoryTranslations,
} from '../../siteFooterLinks/actions';

import {
  ACTION_INIT_DATA__REQUEST,
  ACTION_INIT_DATA__SUCCESS,
  ACTION_INIT_DATA__FAIL,
} from '../actionTypes/initData';


const actionInitDataSuccess = (
  allCountries,
  availableAffiliateProgramTypes,
  siteId,
  reCaptchaKey,
  payoutLimits
) => ({
  type: ACTION_INIT_DATA__SUCCESS,
  payload: {
    allCountries,
    availableAffiliateProgramTypes,
    siteId,
    reCaptchaKey,
    payoutLimits,
  },
});

const actionInitDataFail = error => ({
  type: ACTION_INIT_DATA__FAIL,
  payload: {
    error,
  },
});

export const actionInitSiteDataRequest = () => (
  (dispatch, getState, { apiClientHelper }) => {
    dispatch({
      type: ACTION_INIT_DATA__REQUEST,
    });

    return apiClientHelper.get(
      '/rest/webmaster/init'
    ).then(
      ({
        translations,
        launchAffiliateToolUrl,
        promotedSiteConfigs,
        time,
        timeZone,
        allCountries,
        availableAffiliateProgramTypes,
        wlTemplateToManifestMap,
        wlTemplateToPromotedSiteToLangToCategoryToTranslationMap,
        promotedSiteToContentDefaultTranslations,
        promotedSiteToWlTemplateToLangs,
        siteId,
        reCaptchaKey,
        payoutLimits,
      }) => {
        dispatch(actionAddTranslations(translations));
        dispatch(actionAddLaunchAffiliateToolUrl(launchAffiliateToolUrl));
        dispatch(actionAddPromotedSites(promotedSiteConfigs));
        dispatch(actionAddServerTime(time, timeZone));

        dispatch(actionInitDataSuccess(
          allCountries,
          availableAffiliateProgramTypes,
          siteId,
          reCaptchaKey,
          payoutLimits
        ));
        dispatch(actionAddAllPromotedSiteToWlTemplateToLangs(promotedSiteToWlTemplateToLangs));

        dispatch(actionAddTemplateToCategoriesMap(wlTemplateToManifestMap));
        dispatch(actionAddDefaultSiteLinkCategoryTranslations(
          wlTemplateToPromotedSiteToLangToCategoryToTranslationMap
        ));
        dispatch(actionAddSiteTextsDefaultTranslations(promotedSiteToContentDefaultTranslations));
      },
      error => {
        dispatch(actionInitDataFail(error));
      }
    ).catch(error => {
      dispatch(actionAddException(error));
    });
  }
);
